import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48
}

const ChecklistManagementIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M38.89,3H9.13A4.65,4.65,0,0,0,5,7.79V40.31A4.45,4.45,0,0,0,9.2,45H38.8A4.45,4.45,0,0,0,43,
            40.31V7.79C43,5.15,41.28,3,38.89,3ZM34.64,28.62l-10.86,11a2.3,2.3,0,0,1-1.58.67,2.27,2.27,0,0,
            1-1.61-.7l-5.45-5.53a2.25,2.25,0,0,1,0-3.19L16,30a2.42,2.42,0,0,1,1.62-.67,2.28,2.28,0,0,1,1.6.7l3,
            3,8.37-8.51a2.35,2.35,0,0,1,1.63-.69,2.3,2.3,0,0,1,1.6.72l.9.91A2.22,2.22,0,0,1,34.64,28.62Zm0-16.2-10.86,
            11a2.31,2.31,0,0,1-1.58.68,2.35,2.35,0,0,1-1.61-.7l-5.45-5.54a2.23,2.23,0,0,1,0-3.18l.85-.85a2.42,
            2.42,0,0,1,1.62-.67,2.24,2.24,0,0,1,1.6.7l3,3,8.37-8.51a2.22,2.22,0,0,1,3.23,
            0l.9.92A2.21,2.21,0,0,1,34.64,12.42Z`}
        />
    </SvgIcon>
)

ChecklistManagementIcon.defaultProps = defaultProps

export { ChecklistManagementIcon }
